<template>
  <section
    v-if="!hideWidget(confWidgets.breadcrumbs)"
    :class="[ props.data.parentClasses ]"
  >
    <div :class="props.isAlt ? '' : 'container'">
      <ClientOnly fallback-tag="span">
        <Breadcrumb
          :pt-options="{
            isHead: props.isHead || props.data.isHead,
            isAlt: props.isAlt || props.data.isAlt,
            isCenter: props.isCenter || props.data.isCenter
          }"
          :pt="{
            item: 'flex pb-2'
          }"
          :model="breadcrumbs"
        >
          <template #item="{ item, props: propsItem }">
            <router-link
              v-if="item.route"
              v-slot="{ href, navigate }"
              :to="item.route"
              custom
            >
              <a
                :href="href"
                v-bind="propsItem.action"
                :class="[{ 'font-semibold cursor-default': breadcrumbs[breadcrumbs.length - 1].label === item.label }]"
                @click="navigate"
              >
                <span
                  v-if="item.icon" 
                  :class="[item.icon]"
                />
                <span
                  v-if="item.label"
                >{{ item.label }}</span>
              </a>
            </router-link>

            <a
              v-else
              :href="item.url ? item.url : '#'"
              :target="item.target"
              v-bind="propsItem.action"
              :class="[{ 'opacity-90 cursor-default': breadcrumbs[breadcrumbs.length - 1].label === item.label }]"
            >
              <span
                v-if="item.icon" 
                :class="[item.icon]"
              />
              <span
                v-if="item.label"
              >{{ item.label }}</span>
            </a>
          </template>
        </Breadcrumb>
        
        <template #fallback>
          <Breadcrumb
            :pt-options="{
              isHead: props.isHead || props.data.isHead,
              isAlt: props.isAlt || props.data.isAlt,
              isCenter: props.isCenter || props.data.isCenter
            }"
            :pt="{
              item: 'flex'
            }"
            :model=" [{
              label: $t('breadcrumbs.index'),
              route: '/',
              icon: ''
            }]"
          >
            <template #item="{ item, props: propsItem }">
              <router-link
                v-if="item.route"
                v-slot="{ href, navigate }"
                :to="item.route"
                custom
              >
                <a
                  :href="href"
                  v-bind="propsItem.action"
                  @click="navigate"
                >
                  <span
                    v-if="item.icon" 
                    :class="[item.icon]"
                  />
                  <span
                    v-if="item.label"
                  >{{ item.label }}</span>
                </a>
              </router-link>
            </template>
          </Breadcrumb>
        </template>
      </ClientOnly>
    </div>
  </section>
</template>

<script setup>
const { confGlobal, confWidgets } = useConfig()
const { hideWidget } = useWidgets()
const { breadcrumbs } = useBreadcrumbs()

/**
* Props
*/
const props = defineProps({
  isHead: {
    type: [Boolean],
    default: null
  },
  isAlt: {
    type: [Boolean],
    default: false
  },
  data: {
    type: [Object],
    default: null
  }
})

/**
* Json Schema
*/
/**
* Json Schema
*/
if (breadcrumbs.value) {
  const itemListElement = []
  const items = breadcrumbs.value.slice(0, -1)

  for (const i in items) {
    itemListElement.push({
      '@type': 'ListItem',
      position: i*1 + 1,
      item: {
        '@id': (items[i]
          ? confGlobal.currentSiteUrl.replace(/\/$/, '') + items[i].route
          : confGlobal.currentSiteUrl.replace(/\/$/, '') + (items[i].link || '')
        ),
        name: items[i].label
      }
    })
  }

  if (itemListElement.length) {
    useHead({
      script: [
        {
          type: 'application/ld+json',
          children: JSON.stringify({
            '@context': 'http://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement
          })
        }
      ]
    })
  }
}
</script>

<style lang="scss">
</style>
